export async function readFile(_path: string): Promise<void> {
  throw new Error('readFile not supported in this environment');
}
